import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { BookOpenIcon } from 'lucide-react';
export function Hero() {
  return <div className="relative bg-gradient-to-b from-m3-primary via-m3-surface to-m3-surface-container pt-24 pb-16 overflow-hidden scanlines" data-id="element-76">
      {/* Pixel Grid Background */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `
          linear-gradient(0deg, transparent 24%, rgba(13, 112, 128, 0.3) 25%, rgba(13, 112, 128, 0.3) 26%, transparent 27%, transparent 74%, rgba(13, 112, 128, 0.3) 75%, rgba(13, 112, 128, 0.3) 76%, transparent 77%, transparent),
          linear-gradient(90deg, transparent 24%, rgba(13, 112, 128, 0.3) 25%, rgba(13, 112, 128, 0.3) 26%, transparent 27%, transparent 74%, rgba(13, 112, 128, 0.3) 75%, rgba(13, 112, 128, 0.3) 76%, transparent 77%, transparent)
        `,
      backgroundSize: '50px 50px'
    }} data-id="element-77"></div>

      {/* Floating Pixel Blocks */}
      <motion.div className="absolute top-20 left-10 w-16 h-16 bg-m3-on-surface opacity-20" animate={{
      y: [0, -20, 0],
      rotate: [0, 90, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} style={{
      clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)'
    }} data-id="element-78" />
      <motion.div className="absolute bottom-20 right-20 w-24 h-24 bg-word-current opacity-20" animate={{
      y: [0, 20, 0],
      rotate: [0, -90, 0]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} style={{
      clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)'
    }} data-id="element-79" />
      <motion.div className="absolute top-40 right-40 w-20 h-20 bg-m3-on-surface-variant opacity-20" animate={{
      y: [0, -15, 0],
      x: [0, 15, 0]
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} data-id="element-80" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-81">
        <div className="text-center max-w-4xl mx-auto" data-id="element-82">
          {/* Floating Logo */}
          <motion.div className="flex justify-center mb-8" initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-83">
            <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vdT4rA9mtEjYTkQ7Gc8P9V/snowday_logo_clean.svg" alt="Snow Day Logo" className="w-24 h-24" animate={{
            y: [0, -12, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-84" />
          </motion.div>

          <motion.h1 className="text-6xl sm:text-7xl lg:text-8xl font-bold mb-8 leading-tight" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-85">
            <motion.span className="block text-transparent bg-clip-text bg-gradient-to-r from-m3-on-surface via-m3-on-surface-light to-m3-outline" style={{
            textShadow: '0 0 20px rgba(13,112,128,0.2), 0 0 40px rgba(13,112,128,0.1)'
          }} animate={{
            textShadow: ['0 0 20px rgba(13,112,128,0.2), 0 0 40px rgba(13,112,128,0.1)', '0 0 30px rgba(13,112,128,0.3), 0 0 60px rgba(13,112,128,0.2)', '0 0 20px rgba(13,112,128,0.2), 0 0 40px rgba(13,112,128,0.1)']
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} data-id="element-86">
              Reading Practice
            </motion.span>
            <motion.span className="block text-m3-outline mt-2" style={{
            textShadow: '0 0 20px rgba(69,48,15,0.2)'
          }} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-87">
              Level Up!
            </motion.span>
          </motion.h1>

          <motion.p className="text-base sm:text-lg text-m3-on-surface-variant mb-10 leading-relaxed max-w-3xl mx-auto" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} data-id="element-88">
            Snow Day helps K-12 students build reading comprehension and phonics
            skills through interactive stories, personalized quizzes, and
            adaptive learning experiences.
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-6 justify-center items-center" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.8
        }} data-id="element-89">
            <Button variant="primary" size="lg" href="https://app.snowdayacademy.com" data-id="element-90">
              <BookOpenIcon className="w-5 h-5" data-id="element-91" />
              Start Game
            </Button>
            <Button variant="outline" size="lg" href="#features" data-id="element-92">
              View Features
            </Button>
          </motion.div>

          <motion.div className="mt-12 text-xs text-m3-outline uppercase tracking-widest" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 1
        }} data-id="element-93">
            ★ High Score: 1000+ Players ★
          </motion.div>
        </div>
      </div>
    </div>;
}